export const SANTANDER_SETTINGS = {
  IMPORT_CONFIG: 'ui:santander_import_config',
  IMPORT_ENABLED: 'ff:santander_import_enabled',
} as const;
